module.exports = __webpack_public_path__ + "img/wxqrcode.1907ad83.jpg";